export interface EmailMessages {
  [key: string]: {
    SUBJECT: string
    HTML: string
  }
}

export const Email = {
  ADMIN: {
    EMAIL: '""Tedd+Add" <esemeny@teddmegadd.hu>"',
  },
  MESSAGE: {
    REGISTRATION: {
      SUBJECT: `Tedd+Add: Új regisztráció a weben`,
      HTML: `Új regisztráció a weben keresztül. <br><br>
      <b>Email:</b> {email} <br>
      <b>Név:</b> {displayName} <br><br>
      Az alábbi gombra kattintva lehet a szervezetekhez adni: <br>
      <a href="https://admin.teddmegadd.hu/admin/table-list">
        <button> Szervezetekhez ad</button>
      </a>
      `,
    },
    NEW_EVENT_CREATED: {
      SUBJECT: `Tedd+Add: Új esemény elkészült`,
      HTML: `Új esemény elkészült <br><br>
      <b>Esemény neve:</b> {eventName} <br>
      <b>Szervezet:</b> {organization} <br><br>
      Az alábbi gombra kattintva lehet a jóváhagyni az eseményt <br>
      <a href="https://admin.teddmegadd.hu/admin/event">
        <button>Esemény jóváhagyás</button>
      </a>
      `,
    },
    DELETED_EVENT: {
      SUBJECT: `Tedd+Add: Esemény törölve lett`,
      HTML: `
      Kedves {attendeeName}!<br><br>
      Az alábbi eseményt törölték. <br><br>
      <b>Esemény:</b> {eventName} <br>
      <b>Időpont :</b> {eventDateTimeFrom} - {eventDateTimeTo} <br>
      <b>Helyszín :</b> {eventCity}, {eventAddress} <br>
      <b>Szervező :</b> {eventOrganizer} <br>
      <b>A törlés oka:</b> {reason} <br><br>
      Kérünk, hogy a naptáradból is töröld az eseményt.<br>
      Várunk egy következő önkéntes feladatra, nézd meg most az applikációban, hogy milyen lehetőségek vannak!<br><br>
      Üdvözlettel: <br>
      Tedd+Add csapata
      `,
    },
    DELETED_EVENT_ORGANIZATION: {
      SUBJECT: `Tedd+Add: Esemény törölve lett`,
      HTML: `
      Tisztelt {eventOrganizer}!<br><br>
      Az alábbi esemény törölve lett.<br>
      <b>Esemény:</b> {eventName} <br>
      <b>Időpont :</b> {eventDateTimeFrom} - {eventDateTimeTo} <br>
      <b>Helyszín :</b> {eventCity}, {eventAddress} <br>
      <b>A törlés oka:</b> {reason} <br><br>
      Bízunk benne, hogy hamarosan új önkéntes feladatot hirdet meg a Tedd+Add adminisztrációs felületén.<br><br>
      Munkájához további sok sikert
      kívánunk!<br>
      Tedd+Add csapata
      `,
    },
  } as EmailMessages,
}
